import {Component, inject} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {NgApexchartsModule} from 'ng-apexcharts';
import {TardinessService} from '../../../services/tardiness.service';
import {LineChartSettingsService} from '../line-chart.settings.service';

@Component({
  selector: 'app-tardiness-chart',
  templateUrl: './tardiness-chart.component.html',
  styleUrls: ['./tardiness-chart.component.scss'],
  standalone: true,
  imports: [AsyncPipe, NgApexchartsModule, MatProgressSpinnerModule],
})
export class TardinessChartComponent {
  tardinessService = inject(TardinessService);
  settings = inject(LineChartSettingsService);

  constructor() {
    this.settings = Object.assign(
      {},
      this.settings
        .configureYAxisTitle('Avg. Mins')
        .configureYAxisMin((min) => {
          if (min > 0) {
            min = 0;
          }
          return min - 2;
        })
        .configureYAxisMax((max) => max + 2)
        .configureYAxisTickAmount(6)
        .configureTooltip((val: number, opts?: any): string => {
          if (val === null || val === undefined) return 'No Data';
          return `${Math.round(val * 10) / 10} mins`;
        })
    );
  }
}
